// extracted by mini-css-extract-plugin
module.exports = {"wys":"_3I1BRAJpaROZGpZ76MS3O3"};